import { useContext, useEffect } from "react";
import { DragDropContext } from "./context";

export const useDragDropContext = () => {
  const context = useContext(DragDropContext);
  if (!context) {
    throw new Error("No DragDropContext context was provided.");
  }
  return context;
};
